import { Component, OnInit } from '@angular/core';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { CuestionarioPreguntaRespuesta } from '../../_models/cuestionario-pregunta-respuesta';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { CuestionarioPreguntaRespuestaService } from '../../_services/cuestionario-pregunta-respuesta.service';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';

@Component( {
  selector: 'app-cuestionarios-detalle',
  templateUrl: 'cuestionarios-detalle.component.html'
} )

export class CuestionariosDetalleComponent implements OnInit {

  carInformacionInicial = true;
  cuestionario: Cuestionario;
  cuePreguntas: CuestionarioPregunta[] = [];
  cuePreguntaRespuesta: CuestionarioPreguntaRespuesta[] = [];
  columnas: any[] = [];
  preSeleccionada: CuestionarioPregunta;
  mosPregunta = false;
  colRespuestas: any[] = [];

  constructor( private navServicio: NavService, private cueServicio: CuestionarioService,
               private cuePreguntaServicio: CuestionarioPreguntaService,
               private route: ActivatedRoute,
               private location: Location,
               private cuePreguntaRespuestaServicio: CuestionarioPreguntaRespuestaService ) {
  }

  ngOnInit(): void {
    this.colRespuestas = [
      { field: 'respuesta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_RESPUESTA' ), sort: false },
      { field: 'preguntaDepende', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_PREGUNTADEPENDE' ), sort: false },
      { field: 'indicadorCorrecta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_CORRECTO' ), sort: false }
    ];
    this.columnas = [
      { field: 'pregunta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_PREGUNTA' ), sort: false },
      { field: 'tipoPregunta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_TIPO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
    ];
    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.cueServicio.obtener( params[ 'id' ] ),
        this.cuePreguntaServicio.listadoPorCuestionario( params[ 'id' ] ),
        this.cuePreguntaRespuestaServicio.listadoPorCuestionario( params[ 'id' ] )
      ).subscribe( ( [ cuestionario, lisPreguntas, lisRespuestas ] ) => {
        this.cuestionario = cuestionario;
        this.cuePreguntas = lisPreguntas;
        this.cuePreguntaRespuesta = lisRespuestas;
        this.cargarPreguntasRespuestas();
        this.ordenarPreguntas();
        this.carInformacionInicial = false;
      } );
    } );
  }

  cargarPreguntasRespuestas() {
    this.cuePreguntas.map( ( s: CuestionarioPregunta ) => {
      s.respuestas = this.cuePreguntaRespuesta.filter( x => x.idCuestionarioPregunta === s.idCuestionarioPregunta );
    } );
  }

  private ordenarPreguntas() {
    this.cuePreguntas.sort( function( a, b ) {
      if ( a.orden < b.orden ) {
        return -1;
      } else {
        return 1;
      }
    } );
  }

  regresar() {
    this.location.back();
  }

  ver( cuePregunta: CuestionarioPregunta ) {
    this.preSeleccionada = cuePregunta;
    this.mosPregunta = true;
  }

  cerrar(){
    this.mosPregunta = false;
    this.preSeleccionada = null;
  }
}
